export default {
    _prefix: "qualityFormEditor.questionGroup",
    labels: {
        groupScoreScaleEditor:
            "Group Score Scaling Factor: {{#groupScoreScale}}{{/groupScoreScale}}",
        groupScoreScaleEditorScreenReader: "Change group score scaling factor",
        totalScaledPoints: "Total Scaled Points: {{#ScoreTag}}{{/ScoreTag}}",
    },
    ariaLabels: {
        totalScaledPoints: (data: { value: number }) =>
            "Total Scaled Points: {{value}}",
        groupScoreScaleEditor: (data: { value: number }) =>
            "Group Score Scaling Factor: {{value}}",
    },
    errors: {
        emptyScalingFactor: "Scaling factor must not be empty",
        invalidScalingFactor: "Should be a number between 0 and 999,999.",
    },
};
